import { render, staticRenderFns } from "./WaitingStatusSwitchButton.vue?vue&type=template&id=28f6797e&scoped=true&"
import script from "./WaitingStatusSwitchButton.vue?vue&type=script&lang=js&"
export * from "./WaitingStatusSwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./WaitingStatusSwitchButton.vue?vue&type=style&index=0&id=28f6797e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6797e",
  null
  
)

export default component.exports